import type { Nullable } from 'common/types'

import { convertToBaseEntity } from '../../helpers'
import type { BaseEntity, SelectedTreeObject } from '../../types'
import type { RootState } from '../store'

export const selectActiveEntity = (state: RootState): Nullable<SelectedTreeObject> =>
  state.tree.activeEntity

export const selectActiveEntityColor = (state: RootState): string | undefined =>
  selectActiveEntity(state)?.customProperties?.fillColor

export const selectActiveBaseEntity = (state: RootState): Nullable<BaseEntity> => {
  const entity = selectActiveEntity(state)
  return entity ? convertToBaseEntity(entity) : null
}
